import { fetchWithAuth } from './fetchWithAuth';

export const fetchAttendanceList = async (att_year) => {
  return fetchWithAuth(`/attendance?att_year=${att_year}`);
};

export const fetchAttendanceDetail = async (att_year, seq_no) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}`);
};

export const createAttendance = async (form) => {
  return fetchWithAuth(`/attendance`, { method: 'POST', body: JSON.stringify(form) });
};

export const updateAttendance = async (att_year, seq_no, form) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

export const deleteAttendance = async (att_year, seq_no) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}`, { method: 'DELETE' });
};

export const fetchApplyList = async (att_year, seq_no) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}/apply`);
};

export const scanAttend = async (att_year, seq_no, emp_no, att_round) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}/scan`, {
    method: 'POST', body: JSON.stringify({ emp_no, att_round }),
  });
};

export const deleteApply = async (att_year, seq_no, emp_no, att_round) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}/apply/${emp_no}/${att_round}`, { method: 'DELETE' });
};

export const fetchUnfinishedMembers = async (att_year, seq_no, att_round) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}/unfinished/${att_round}`);
};

export const fetchEducationNoShow = async (att_year, seq_no) => {
  return fetchWithAuth(`/attendance/${att_year}/${seq_no}/noshow`);
};

export const bulkCreateAttendance = async (data) => {
  return fetchWithAuth(`/attendance/bulk-create`, { method: 'POST', body: JSON.stringify(data) });
};